<template>
  <v-bottom-navigation app class="teal lighten-1" dark fixed grow>
    <template v-for="(link, index) in links">
      <v-btn v-if="link && link.url" :key="index" :to="link.url">
        <span>{{link.name}}</span>
        <v-icon>{{link.icon}}</v-icon>
      </v-btn>
      <v-btn v-else :key="index">
        <span>{{link.name}}</span>
        <v-icon>{{link.icon}}</v-icon>
      </v-btn>
    </template>
  </v-bottom-navigation>
</template>

<script>
export default {
  data() {
    return {
      links: [
        {
          icon: 'mdi-home',
          url: '/',
          name: 'Home'
        },
        {
          icon: 'mdi-briefcase',
          url: '',
          name: 'Projects'
        },
        {
          icon: 'mdi-file-document-box-search',
          url: '',
          name: 'Research'
        },
        {
          icon: 'mdi-email-send',
          url: '/contact',
          name: 'Contact'
        }
      ]
    }
  }
}
</script>